<template>
  <div class="newproductdetail" v-if="info" v-wechat-title="info.iteminfo.name">
    <div ref="ifscroll" class="swiper-container" id="pro_pic" style="height: auto">
      <div
        :style="[!playShow ? { 'z-index': -1 } : {}]"
        v-show="info.iteminfo.video_play_url != ''"
      >
        <div class="swiper-slide" style="background: #333; height: 100%">
          <div
            style="width: 100%; height: 100%"
            v-if="info.iteminfo.video_img_url != null && info.iteminfo.video_img_url != ''"
          >
            <img :src="info.iteminfo.video_img_url" @load="loadvideo" style="display: none" />
            <div class="zy_media" style="width: 100%; height: 100% !important">
              <video
                id="banner_video"
                style="width: 100%; height: 100%"
                :poster="info.iteminfo.video_img_url"
                data-config="创客村"
                webkit-playsinline="true"
                playsinline="true"
                x5-playsinline="true"
                x-webkit-airplay="allow"
                preload="true"
              >
                <source :src="info.iteminfo.video_play_url" type="video/mp4" />
                <source :src="info.iteminfo.video_play_url" type="video/m3u8" />
                您的浏览器不支持HTML5视频
              </video>
            </div>
          </div>
          <div
            class="play_false"
            style="
              position: absolute;
              left: 0;
              top: 0;
              background: #f5f5f5;
              width: 100%;
              height: 100%;
            "
            v-if="!playShow"
          ></div>
        </div>
      </div>
      <div
        :style="[
          !imgShow ? { 'z-index': -1 } : {},
          !info.iteminfo.video_play_url != '' ? { position: 'relative' } : {}
        ]"
        class="swiper-wrapper swiper_banner"
      >
        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
          <img
            :style="{ height: info.iteminfo.img_path_height / 200 + 'rem' }"
            v-lazy="item"
            @click="preview(item, index, 'banner')"
          />
        </div>
      </div>
      <div
        id="proSwiperPagination"
        v-show="imgShow"
        class="swiper-pagination swiper-pagination-fraction"
        v-if="bannerList && bannerList.length > 0"
      >
        <div class="pro_page">{{ activeIndex + 1 }} / {{ bannerList.length }}</div>
      </div>
      <div class="playTab" v-if="info.iteminfo.video_play_url != ''">
        <span
          @click="playTab(0)"
          :style="
            playShow
              ? {
                  background: 'linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%)',
                  border: '0.01rem solid transparent',
                  color: '#FFFFFF'
                }
              : {}
          "
        >
          <van-icon :color="playShow ? '#ffffff' : '#353535'" size="0.11rem" :name="icon" />
          <b>视频</b>
        </span>
        <span
          @click="playTab(1)"
          :style="
            imgShow
              ? {
                  background: 'linear-gradient(90deg,rgba(252,3,36,1) 0%,rgba(246,58,102,1) 100%)',
                  border: '0.01rem solid transparent',
                  color: '#FFFFFF'
                }
              : {}
          "
        >
          <b>图片</b>
        </span>
      </div>
    </div>
    <div
      class="status flex-js-ac"
      :class="{
        cyan: info.status == 0,
        red: info.status == 1,
        'orange width': info.status == 2,
        'yellow width': info.status == 3
      }"
    >
      <div
        class="f14"
        :class="{
          cyan: info.status == 0,
          red: info.status == 1,
          orange: info.status == 2,
          yellow: info.status == 3
        }"
      >
        {{
          info.status == 0
            ? '即将开始'
            : info.status == 1
            ? '正在进行'
            : info.status == 2
            ? '待开奖'
            : '已开奖'
        }}
      </div>
      <span
        class="f12"
        :class="{ 'flex-1': info.status == 2 || info.status == 3 }"
        @click="lottery"
      >
        {{ info.status == 0 ? '距离开始还有：' : '' }}
        {{ info.status == 1 ? '距离结束还有：' : '' }}
        <van-count-down
          v-if="info.status == 0 || info.status == 1"
          @finish="finishFn"
          :time="time"
          format="DD天HH时mm分ss秒"
        />
        {{ info.status == 2 ? '已结束' : '' }}
        {{ info.status == 3 ? '开奖名单' : '' }}
      </span>
    </div>
    <div class="pro_name">
      <div class="integralnum f12 flex-ac">
        <img src="/static/images/newproducttrial/new_product-icon-money@2x.png" />
        x
        <span>{{ info.point }}</span>
        <i>
          ￥{{
            info.iteminfo.cost_bottom_price != info.iteminfo.cost_top_price
              ? info.iteminfo.cost_bottom_price + '-' + info.iteminfo.cost_top_price
              : info.iteminfo.cost_bottom_price
          }}
        </i>
      </div>
      <div class="name w-b f16">
        {{ info.iteminfo.name }}
      </div>
      <div class="flex-js-ac">
        <span class="f12 color-FC0324">限量{{ info.limitnum }}份</span>
        <span class="f12 gray">浏览{{ info.viewnum }}</span>
      </div>
    </div>
    <div
      class="pro_name powerlist"
      v-if="info.status != 0"
      @click="$router.push('/powerlist?actid=' + $route.query.id)"
    >
      <div class="title flex-js-ac">
        <p class="f14">
          <b>已助力</b>
          {{ info.helpdata.totalnum > 999 ? '999+' : info.helpdata.totalnum }}人
          <span class="color-FC0324">(新用户助力+10个助力值)</span>
        </p>
        <span class="f12 flex-ac">
          查看全部
          <van-icon name="arrow" size="0.08rem" color="#1D1E1E" />
        </span>
      </div>
      <div class="personlist flex-ac" v-if="info.helpdata.list.length">
        <img
          v-for="item of info.helpdata.list"
          :src="item"
          @error="
            (event) => {
              let img = event.srcElement
              img.src = errorHeadImg
              img.onerror = null
            }
          "
        />
      </div>
    </div>
    <div
      class="pro_name powerlist"
      v-if="info.status != 0 && info.status != 3 && info.applydata.list.length"
      @click="$router.push('/applylist?actid=' + $route.query.id)"
    >
      <div class="title flex-js-ac">
        <p class="f14">
          <b>已申请</b>
          {{ info.applydata.totalnum > 999 ? '999+' : info.applydata.totalnum }}人
        </p>
        <span class="f12 flex-ac">
          查看全部
          <van-icon name="arrow" size="0.08rem" color="#1D1E1E" />
        </span>
      </div>
      <div class="personlist flex-ac">
        <img
          v-for="item of info.applydata.list"
          :src="item"
          @error="
            (event) => {
              let img = event.srcElement
              img.src = errorHeadImg
              img.onerror = null
            }
          "
        />
      </div>
    </div>
    <div
      class="pro_name powerlist"
      v-if="info.status == 3 && info.feedbackdata.list.length"
      @click="$router.push('/trialfeedback?actid=' + $route.query.id)"
    >
      <div class="title flex-js-ac">
        <p class="f14">
          <b>试用反馈</b>
          {{ info.feedbackdata.totalnum > 999 ? '999+' : info.feedbackdata.totalnum }}人
        </p>
        <span class="f12 flex-ac">
          查看全部
          <van-icon name="arrow" size="0.08rem" color="#1D1E1E" />
        </span>
      </div>
      <div class="personlist flex-ac">
        <img
          v-for="item of info.feedbackdata.list"
          :src="item"
          @error="
            (event) => {
              let img = event.srcElement
              img.src = errorHeadImg
              img.onerror = null
            }
          "
        />
      </div>
    </div>
    <div class="pro_name process">
      <div class="title f14">试用流程</div>
      <img src="/static/images/newproducttrial/liucheng.png?v=3" />
      <div class="f13 rules">
        {{
          info.actdesc.length > 95
            ? !isan
              ? info.actdesc.substring(0, 95) + '...'
              : info.actdesc
            : info.actdesc
        }}
        <span class="color-FC0324" v-if="info.actdesc.length > 95" @click="isan = !isan">
          {{ !isan ? '展开全部' : '收起' }}
        </span>
      </div>
    </div>
    <div class="pro_name process pro_details footerIOS" v-if="info.iteminfo.descriptions">
      <div class="title f14 pro_details_tit">商品详情</div>
      <div class="pro_details_con pb10">
        <img
          v-for="(item, index) of info.iteminfo.descriptions"
          v-lazy="item.path"
          @click="preview(item, index, 'description')"
        />
      </div>
    </div>
    <div class="footerbtn footerIOS">
      <div
        v-if="info.applyStatus != 1 && info.status == 1"
        class="color-FC0324 f13 flex ai-c pb12 radius-2px"
        :class="[info.applyStatus == 3 ? ' jc-c' : 'jc-sb']"
      >
        <span>{{ info.supText }}</span>
        <span v-if="info.applyStatus == 2" @click="goSup">
          去补充
          <van-icon name="arrow" size="0.1rem" />
        </span>
      </div>
      <div class="flex-js-as pb10">
        <img
          v-if="info.status == 1 && info.ifapply == 1"
          @click="isshare = true"
          src="/static/images/newproducttrial/power@2x.gif?v=1"
        />
        <img v-else @click="isshare = true" src="/static/images/newproducttrial/share@2x.png?v=1" />
        <div class="flex-ac flex-1">
          <button class="f13 flex-1 left" v-if="info.linkitemid" @click="goProductDetail">
            立即购买
          </button>
          <button
            class="f13 flex-1 right"
            @click="submit"
            :class="{
              cyan: info.status == 0,
              yellow: info.status == 1,
              orange: info.status == 2,
              'yellow-01': info.status == 3
            }"
          >
            {{ info.status == 0 ? (info.issubscribe == 0 ? '活动开始通知' : '已订阅活动') : '' }}
            {{
              info.status == 1
                ? info.ifapply == 0
                  ? parseInt(info.limitpoint) >= parseInt(info.point)
                    ? '申请试用（' + info.point + '个金币）'
                    : '金币不足，前去获取'
                  : '已申请'
                : ''
            }}
            {{ info.status == 2 ? '待开奖' : '' }}
            {{ info.status == 3 ? '已开奖' : '' }}
          </button>
        </div>
      </div>
    </div>
    <div class="sharefriend" v-if="isshare == true">
      <img @click="isshare = false" src="/static/wx/img/sharebg2.png" />
    </div>
    <van-overlay :show="show" v-if="show" z-index="99999">
      <div class="wrapper">
        <div class="block">
          <div class="winninglist">
            <p class="f17">中奖名单</p>
            <div class="scroll" @touchmove.stop>
              <div class="winninglistitem flex-ac" v-for="(item, index) of info.winninglist">
                <img
                  v-if="index < 3"
                  :src="
                    index == 0
                      ? '/static/images/newproducttrial/no1@2x.png'
                      : index == 1
                      ? '/static/images/newproducttrial/no2@2x.png'
                      : '/static/images/newproducttrial/no3@2x.png'
                  "
                />
                <span v-else class="f13">{{ index + 1 }}</span>
                <img
                  class="headimg"
                  :src="item.headimg"
                  @error="
                    (event) => {
                      let img = event.srcElement
                      img.src = errorImg
                      img.onerror = null
                    }
                  "
                />
                <p class="f13 over-ell-1">{{ item.name }}</p>
              </div>
            </div>
            <div class="footer" v-if="info.winninglist.length > 6"></div>
          </div>
          <van-icon @click="show = false" name="close" size="0.3rem" color="#A6A6A6" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="receiveShow" v-if="receiveShow" z-index="99999">
      <div class="wrapper">
        <div class="block pos-r" style="width: 66%">
          <img src="/static/images/newproducttrial/popup-window@2x.png?v=1" />
          <div class="pos-a l0 r0 b0 flex pl20 pr20 pb20">
            <van-button
              class="mr10 flex-1"
              color="#FC0324"
              round
              plain
              type="info"
              size="small"
              @click="golink"
            >
              {{ isnewuser == 1 ? '新人福利' : '我知道了' }}
            </van-button>
            <van-button
              class="flex-1"
              round
              color="#FC0324"
              type="info"
              size="small"
              @click="receiveShow = false"
            >
              我也参与
            </van-button>
          </div>
          <!--          <van-icon @click="qrcodeurl = ''" name="close" size="0.3rem" />-->
        </div>
      </div>
    </van-overlay>
    <div class="floatbtn" v-if="$route.query.shareOpenid">
      <img
        @click="$router.push('/newproducthome')"
        src="/static/images/newproducttrial/newpro@2x.png"
      />
    </div>
    <van-sku
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :goods-id="productId"
      :quota="maxNum"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" @click="openPreview" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname == '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price pro_name">
              <!--              <span class="van-sku__price-symbol">¥</span><span class="van-sku__price-num">{{skuprice}}</span>-->
              <div class="integralnum f12 flex-ac">
                <img src="/static/images/newproducttrial/new_product-icon-money@2x.png" />
                x
                <span>{{ info.point }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            size="large"
            type="danger"
            class="sure"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked"
          >
            确定
          </van-button>
        </div>
      </template>
    </van-sku>
    <sku-preview
      v-if="info.iteminfo.sku_rule_list"
      hide-price
      hide-add-cart-button
      hide-buy-button
      ref="skuPreview"
      :sku-list="info.iteminfo.sku_rule_list"
      @change="changePreview"
    />
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, fenxiang, Base64 } from '../../assets/common/js/config'
import { Sku, ImagePreview } from 'vant'
import Vue from 'vue'
import skufunc from '../../assets/common/js/sku_func'
import skuPreview from '../common/skuPreview.vue'

Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(ImagePreview)

export default {
  name: 'newproductdetail',
  components: {
    [Sku.name]: Sku,
    skuPreview
  },
  data() {
    return {
      bannerList: [],
      activeIndex: 0,
      info: null,
      time: 0,
      show: false,
      showsku: false,
      skuname: '',
      skuprice: '',
      sureGray: false,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      productId: null,
      maxNum: null,
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            let msg = `数量超出范围~`
            this.$toast(msg)
            // console.log(limitType)
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 0,
        stockFormatter: (stockNum) => {}
      },
      i: 0,
      isan: false,
      isshare: false,
      receiveShow: false,
      icon: 'play',
      playShow: false,
      imgShow: false,
      isnewuser: 0,
      link: '',
      selectedSkuIndex: -1
    }
  },
  watch: {
    show(n) {
      if (n) {
        document.getElementById('app').style.overflow = 'hidden'
      } else {
        document.getElementById('app').style.overflow = 'initial'
      }
    }
  },
  mounted: function () {
    this.getBrowse()
    this.getData()
  },
  destroyed: function () {},
  methods: {
    getBrowse() {
      var url = this.$ajax.addBrowse_URL,
        data = {
          actid: this.$route.query.id
        }
      this.$customRequestAjax.post(url, data)
    },
    getShare() {
      if (!this.$route.query.shareOpenid) return
      var url = this.$ajax.addShare_URL,
        data = {
          shareToken: this.$route.query.shareOpenid,
          actid: this.$route.query.id
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          this.link = res.data.link
          this.isnewuser = res.data.isnewuser ? res.data.isnewuser : 0
          if (res.data.ismyself != 1 && res.data.msg) {
            this.receiveShow = true
          }
        }
      })
    },
    golink: function () {
      var that = this
      this.receiveShow = false
      if (this.isnewuser == 1) {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'ztonew'
          }
        })
        if (this.link) {
          setTimeout(function () {
            window.location = that.link
          }, 500)
        }
      } else {
        this.$router.push('/')
      }
    },
    getData() {
      var url = this.$ajax.getDetail_URL + '?actid=' + this.$route.query.id,
        that = this
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.info = res.data.data
          this.$route.meta.title = this.info.iteminfo.name
          if (this.info.sharevalue > 0) {
            this.$dialog
              .alert({
                title: '反馈奖励',
                message: `感谢您的用心反馈，恭喜您获得官方${this.info.sharevalue}个助力值！期待您的下次参与。`,
                className: 'percen_button_alert newproduct_button_alert',
                confirmButtonColor: '#FFFCFC',
                confirmButtonText: '我知道了',
                closeOnPopstate: false
              })
              .then(function () {
                // on confirm
              })
          }
          this.getShare()
          if (this.info.status == 0 || this.info.status == 1) {
            let currtime = new Date().getTime(),
              limittime = new Date(this.info.limittime.replace(/-/g, '/')).getTime()
            this.time = limittime - currtime
          }
          this.bannerList = this.info.iteminfo.img_paths
          this.info.iteminfo.video_img_url = this.info.iteminfo.video_img_url
            ? this.info.iteminfo.video_img_url
            : ''
          this.info.iteminfo.video_play_url = this.info.iteminfo.video_play_url
            ? this.info.iteminfo.video_play_url
            : ''
          if (this.info.iteminfo.video_img_url != '' || this.info.iteminfo.video_play_url != '') {
            this.playShow = true
            this.imgShow = false
          } else {
            this.playShow = false
            this.imgShow = true
          }
          this.$nextTick(function () {
            new Swiper('#pro_pic', {
              autoplay: false,
              observer: true,
              observeParents: true,
              on: {
                slideChangeTransitionStart: function () {
                  that.activeIndex = this.activeIndex
                }
              }
            })
          })
          if (isWeixin()) {
            var base = new Base64()
            if (this.info.shareinfo && this.info.shareinfo.sharetitle) {
              let title = encodeURIComponent(this.info.shareinfo.sharetitle),
                desc = encodeURIComponent(this.info.shareinfo.sharedesc),
                img = this.info.shareinfo.shareimg
              fenxiang({
                title: title,
                desc: desc,
                imgx: img,
                type: 'newproductdetail',
                dataStr:
                  'type=newproductdetail&params=' +
                  base.encode(JSON.stringify({ id: this.$route.query.id })),
                path: 'newproductdetail'
              })
            } else {
              fenxiang({ path: 'newproductdetail' })
            }
          }
        }
      })
    },
    preview(items, index, type) {
      var imgArr, newImgArr
      if (type == 'banner') {
        newImgArr = this.bannerList
      } else if (type == 'description') {
        newImgArr = []
        this.info.iteminfo.descriptions.map((item) => {
          if (item && item != undefined) {
            newImgArr.push(item.path)
          }
        })
      }
      ImagePreview({
        images: newImgArr,
        startPosition: index,
        closeOnPopstate: true
      })
    },
    playTab(num) {
      if (num == 0) {
        if (this.playShow) {
          if (this.icon == 'play') {
            document.querySelectorAll('.zy_media video')[0].play()
            this.icon = 'pause'
          } else {
            document.querySelectorAll('.zy_media video')[0].pause()
            this.icon = 'play'
          }
        }
        this.$nextTick(function () {
          this.playShow = true
          this.imgShow = false
        })
      } else if (num == 1) {
        document.querySelectorAll('.zy_media video')[0].pause()
        this.playShow = false
        this.imgShow = true
      }
    },
    loadvideo: function () {
      var that = this
      setTimeout(function () {
        zymedia('#banner_video', {
          aspectRation: that.info.iteminfo.img_path_width / that.info.iteminfo.img_path_height,
          preload: 'auto',
          hideVideoControlsOnLoad: true
        })
      })
    },
    finishFn() {
      this.getData()
    },
    lottery() {
      if (this.info.status == 3) {
        this.show = true
      }
    },
    goSup() {
      sessionStorage.setItem('newproductdetail_shareinfo', JSON.stringify(this.info.shareinfo))
      const query = {
        ...this.$route.query,
        actid: this.$route.query.id,
        skuid: this.info.applySkuid,
        integral: this.info.point
      }
      this.$router.push({
        path: '/applytrial',
        query
      })
    },
    submit() {
      if (this.info.status == 0 && this.info.issubscribe == 0) {
        this.subscribe()
      } else if (this.info.status == 1) {
        if (this.info.ifapply == 0 && parseInt(this.info.limitpoint) >= parseInt(this.info.point)) {
          if (this.info.isblack == 1) {
            this.$dialog
              .alert({
                title: '',
                message: '您已被加入黑名单，不能申请试用，如有疑问请联系官方客服',
                className: 'percen_button_alert',
                confirmButtonColor: '#FFFCFC',
                confirmButtonText: '我知道了',
                closeOnPopstate: false
              })
              .then(function () {
                // on confirm
              })
          } else {
            this.openSku()
          }
        } else if (
          this.info.ifapply == 0 &&
          parseInt(this.info.limitpoint) < parseInt(this.info.point)
        ) {
          this.$router.push({
            path: '/integralTask'
          })
        }
      }
    },
    subscribe() {
      var url = this.$ajax.addSubscribe_URL,
        that = this,
        data = {
          actid: this.$route.query.id
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          this.$dialog
            .alert({
              title: '设置提醒成功',
              message: '活动开始后将通过系统消息通知您',
              className: 'percen_button_alert integral_button_alert text-align-center',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '我知道了',
              closeOnPopstate: false
            })
            .then(function () {
              // on confirm
              that.getData()
            })
        }
      })
    },
    openPreview() {
      this.$refs.skuPreview.showPreview(this.selectedSkuIndex)
      skufunc.selectedSkuHandle(this.selectedSkuIndex, this)
    },
    changePreview(index) {
      skufunc.selectedSkuHandle(index, this)
    },
    checkedSku(skuValue) {
      skufunc.checkedSku_newproductdetail(skuValue, this)
    },
    openSku() {
      skufunc.openSku_newproductdetail(this)
    },
    onConfirmClicked() {
      skufunc.onConfirmClicked_newproductdetail(this)
    },
    goProductDetail() {
      this.$clickburiedPoint({
        url: 'ckysdatacenter/itemclick/save',
        data: {
          itemid: this.info.linkitemid,
          scenepoint: 'NEWPRODUCTACT'
        }
      })
      this.$router.push('/productdetail?itemid=' + this.info.linkitemid)
    }
  }
}
</script>

<style scoped lang="scss">
.newproductdetail {
  padding-bottom: 0.7rem;
  .swiper-container {
    .swiper-wrapper {
      margin: 0;
      padding: 0;
      /*height: 100%;*/
      &.swiper_banner {
        position: absolute;
        left: 0px;
        top: 0px;
      }
      .swiper-slide {
        padding: 0;
        margin: 0;
        position: relative;
        background: #f5f5f5;
        img {
          width: 100%;
          display: block;
          border: 0;
          object-fit: contain;
        }
      }
    }
    #proSwiperPagination {
      font-size: 0.12rem;
      width: 0.34rem;
      color: #fff;
      position: absolute;
      right: 0.11rem;
      left: auto;
      /*<!--margin-left: -.17rem;-->*/
      bottom: 0.15rem;
      .pro_page {
        /*position: relative;*/
        background: url(../../assets/images/pagebg.png) no-repeat center;
        background-size: 100% 100%;
        padding: 0 0.0385rem 0.01rem;
        white-space: nowrap;
        .swiper-pagination-current {
          width: 0.12rem;
          border-radius: 0.12rem;
          /*position: absolute;*/
          /*top: 0;*/
          /*left: 0;*/
          /*background: #757575;*/
        }
        .swiper-pagination-split {
          margin-left: 0.02rem;
          margin-right: 0.02rem;
          /*position: absolute;*/
          /*top: 0;*/
          left: 0.08rem;
          height: 0.12rem;
          line-height: 0.12rem;
          margin-top: 0.01rem;
          /*background: #757575;*/
          text-align: center;
          font-size: 0.12rem;
          transform: scale(0.8);
        }
        .swiper-pagination-total {
          width: 0.12rem;
          border-radius: 0.12rem;
          /*position: absolute;*/
          /*top: 0;*/
          left: 0.14rem;
          /*background: #757575;*/
        }
      }
    }
    .playTab {
      /*font-size: 0;*/
      text-align: center;
      position: absolute;
      bottom: 0.15rem;
      z-index: 1;
      left: 0;
      right: 0;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -o-flex;
      display: -ms-flex;
      justify-content: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      -o-justify-content: center;
      -ms-justify-content: center;
      span {
        width: 0.47rem;
        height: 0.22rem;
        text-align: center;
        background: rgba(249, 249, 249, 1);
        border-radius: 0.11rem;
        border: 0.01rem solid rgba(224, 225, 224, 1);
        font-size: 0.11rem;
        font-weight: 400;
        color: rgba(53, 53, 53, 1);
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -o-flex;
        display: -ms-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -o-align-items: center;
        -ms-align-items: center;
        justify-content: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -o-justify-content: center;
        -ms-justify-content: center;
        b {
          font-weight: 400;
          transform: scale(0.98);
          -webkit-transform: scale(0.98);
          -moz-transform: scale(0.98);
          -ms-transform: scale(0.98);
          -o-transform: scale(0.98);
        }
        &:first-of-type {
          margin-right: 0.045rem;
        }
        &:last-of-type {
          margin-left: 0.045rem;
        }
      }
    }
  }
  .status {
    color: #ffffff;
    border-radius: 0.16rem 0.16rem 0 0;
    height: 0.4rem;
    margin: 0.1rem 0.15rem 0;
    padding-right: 0.15rem;
    &.red {
      background: #f95f73;
    }
    &.orange {
      background: #ff966d;
    }
    &.yellow {
      background: #fcc270;
    }
    &.cyan {
      background: #4fdeba;
    }
    &.width {
      width: 1.72rem;
    }
    div {
      height: 100%;
      width: 0.86rem;
      text-align: center;
      border-radius: 0.16rem 0 0.16rem 0;
      line-height: 0.2rem;
      padding: 0.1rem 0;
      &.red {
        background: #fc0324;
      }
      &.orange {
        background: #fb6e38;
      }
      &.yellow {
        background: #ffb346;
      }
      &.cyan {
        background: #20cba1;
      }
    }
    .van-count-down {
      display: inline;
      padding: 0;
      color: #ffffff;
      font-size: 0.12rem;
    }
    span {
      padding-left: 0.15rem;
      text-align: center;
    }
  }
  .pro_name {
    background: #ffffff;
    padding: 0.15rem 0.15rem 0.1rem;
    margin-bottom: 0.1rem;
    .integralnum {
      color: #292929;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.04rem;
      }
      span {
        font-weight: bold;
        margin-right: 0.08rem;
        font-size: 0.25rem;
      }
      i {
        font-style: normal;
        color: #929292;
        text-decoration: line-through;
      }
    }
    .name {
      color: #292929;
      font-weight: bold;
      margin-top: 0.12rem;
      margin-bottom: 0.08rem;
    }
    .gray {
      color: #979797;
    }
  }
  .powerlist {
    .title {
      p {
        color: #292929;
        b {
          margin-right: 0.08rem;
        }
      }
      span {
        color: #979797;
        &.color-FC0324 {
          color: #fc0324;
        }
      }
    }
    .personlist {
      margin-top: 0.17rem;
      img {
        width: 0.28rem;
        height: 0.28rem;
        border-radius: 50%;
        border: 0.01rem solid #ffffff;
        margin-left: -0.05rem;
        &:first-child {
          margin-left: 0;
        }
      }
    }
  }
  .process {
    .title {
      color: #292929;
      font-weight: bold;
    }
    img {
      width: 100%;
      margin: 0.15rem 0 0.17rem;
    }
    .rules {
      color: #666666;
      line-height: 0.22rem;
      position: relative;
      span {
        position: absolute;
        right: 0;
        bottom: 0;
        padding-left: 0.02rem;
        background: #ffffff;
      }
    }
  }
  .footerbtn {
    background: #ffffff;
    position: fixed;
    width: 100%;
    bottom: -0.02rem;
    padding: 0.06rem 0.11rem;
    min-height: 0.51rem;
    img {
      width: 0.38rem;
      height: 0.38rem;
      margin-right: 0.05rem;
    }
    div {
      /*width: 85%;*/
      border-radius: 0.19rem;
      overflow: hidden;
      button {
        height: 0.36rem;
        border-width: 0;
        color: #ffffff;
        &.left {
          background: linear-gradient(90deg, #fc0324 0%, #ff144f 100%);
        }
        &.right {
          &.orange {
            background: linear-gradient(90deg, #fb6e38 0%, #ff966d 100%);
          }
          &.yellow {
            background: linear-gradient(90deg, #ffa700 0%, #ffba00 100%);
          }
          &.yellow-01 {
            background: linear-gradient(90deg, #ffb346 0%, #fcc270 100%);
          }
          &.cyan {
            background: linear-gradient(90deg, #ffa700 0%, #20cba1 0%, #4fdeba 100%);
          }
        }
      }
    }
  }
  .block {
    width: 84%;
    .winninglist {
      position: relative;
      border-radius: 0.04rem;
      width: 100%;
      height: 3.03rem;
      background: #ffffff;
      > p {
        color: #333333;
        font-weight: bold;
        margin-bottom: 0.06rem;
      }
      .scroll {
        max-height: 2.5rem;
        padding-top: 0;
        padding-bottom: 0.3rem;
        padding-left: 0;
        overflow-y: scroll;
      }
      .winninglistitem {
        padding-left: 0;
        img {
          width: 0.16rem;
          height: 0.16rem;
          border-radius: 50%;
          &.headimg {
            width: 0.24rem;
            height: 0.24rem;
            margin-right: 0.08rem;
            margin-left: 0.1rem;
          }
        }
        span {
          color: #ceccc8;
          min-width: 0.16rem;
        }
        p {
          color: #333333;
          font-weight: bold;
          margin: 0;
        }
      }
      .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        background: url(/static/images/newproducttrial/popfo.png) center;
        background-size: 100%;
        width: 100%;
        height: 0.39rem;
        border-radius: 0.04rem;
        padding: 0;
      }
    }
  }
  .sharefriend {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2;
  }
  .sharefriend img {
    width: 100%;
  }
  .floatbtn {
    position: fixed;
    right: 0.16rem;
    bottom: 0.85rem;
    img {
      width: 0.5rem;
      height: 0.5rem;
    }
  }
}
</style>
<style lang="scss">
.percen_button_alert.van-dialog.newproduct_button_alert {
  width: 84% !important;
}
.percen_button_alert.van-dialog.newproduct_button_alert .van-dialog__header {
  padding-top: 0.2rem;
  font-size: 0.14rem;
}
.percen_button_alert.van-dialog.newproduct_button_alert .van-dialog__content {
  padding-top: 0.17rem;
}
.percen_button_alert.van-dialog.newproduct_button_alert .van-dialog__footer {
  padding: 0.11rem 0 0.3rem;
}
.percen_button_alert.van-dialog.newproduct_button_alert .van-dialog__message {
  padding-left: 0.28rem;
  padding-right: 0.17rem;
}
.newproductdetail {
  .pro_details {
    .pro_details_con {
      margin-top: 0.15rem;
      img {
        width: 100% !important;
        margin: 0;
      }
      video {
        width: 100%;
      }
    }
  }
  .good_sku {
    .van-icon-cross {
      background: url('../../assets/images/close3.png') no-repeat center;
      background-size: 100%;
      color: transparent;
    }
  }
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }
  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }
  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
    padding: 0;
    img {
      width: 0.15rem !important;
      height: 0.15rem !important;
    }
    span {
      font-size: 0.15rem !important;
    }
  }
  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }
  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }
  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }
  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }
  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
  }
  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }
  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }
  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
  }
  .good_sku .van-stepper__minus::before,
  .van-stepper__plus::before {
    width: 9px;
  }
  .good_sku .van-stepper__minus::after,
  .van-stepper__plus::after {
    height: 9px;
  }
  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;
    &:before {
      background: #fcfcfc;
    }
  }
  .van-sku-stepper-stock {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newproducttrial/newproductdetail.vue